
import { elk } from '@tencent/ppd-base-libs';
const RESOURCE_NAME = 'https://st.moneydata.hk/wuji/config/cross_travel/crossTravelIndexV2.json';

/**
 * 上报配置内容获取耗时
 */
export function reportLoadConfigTiming() {
  try {
    // 获取所有网络请求的性能条目
    const entry = performance.getEntriesByType('resource').find(item => item.name.startsWith(RESOURCE_NAME));
    if (entry) {
      elk({
        key: 'crossTravelIndexV2_timing',
        num1: parseInt(entry.duration.toString(), 10),
      });
    }
  } catch (error) {

  }
}
